import { useState, useEffect } from 'react';
import { doc, onSnapshot, DocumentData } from 'firebase/firestore';
import { db } from '../config/firebase'; // Assumendo che db sia esportato da qui

const useBatchListener = (batchId: string | null) => {
    const [batchData, setBatchData] = useState<DocumentData | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        if (!batchId) {
            setLoading(false);
            setBatchData(null);
            return;
        }

        setLoading(true);
        setError(null);

        const docRef = doc(db, 'batches', batchId);

        const unsubscribe = onSnapshot(
            docRef,
            (docSnap) => {
                if (docSnap.exists()) {
                    setBatchData(docSnap.data());
                } else {
                    setError('Batch not found or access not authorized.');
                    setBatchData(null);
                }
                setLoading(false);
            },
            (err) => {
                console.error("Error while listening to batch:", err);
                setError('An error occurred while fetching batch data.');
                setLoading(false);
            }
        );

        // Funzione di pulizia per annullare l'iscrizione quando il componente viene smontato
        return () => {
            unsubscribe();
        };
    }, [batchId]);

    return { batchData, loading, error };
};

export default useBatchListener;
